/**
 * For Theme configuration details, see https://material-ui.com/customization/theming/
 * When modifying colours, consider using this tool provided by Material UI
 * https://material.io/tools/color/
 *
 */
import { createTheme, responsiveFontSizes } from '@mui/material/styles';

import { PaletteMode } from '@mui/material';
import { CommonColors } from '@mui/material/styles/createPalette';

export const colors: CommonColors = {
    lightGreen: '#63b84c',
    green: '#2e871c',
    darkGreen: '#005900',
    lightRed: '#fd824a',
    red: '#c4531e',
    darkRed: '#8d2400',
    // Old Legacy colours used from V1
    lightGrey: '#E4E4E6',
    xlightGrey: '#F4F4F7',
    black: '#000',
    black70: 'rgba(0,0,0,0.7)',
    grey: '#696969',
    neutralDark: '#64737D',
    neutral: '#808F99',
    neutralLight: '#CAD0D4',
    neutralXLight: '#DAE0E4',
    neutralXXLight: '#F6F6F6',
    neutralXXXLight: '#FAFAFA',
    white: '#FFF',
    blue: '#1368D8',
};

const generateTheme = (mode: PaletteMode, useResponsiveFontSizes = true) => {
    const theme = createTheme({
        palette: {
            mode,
            common: colors,
            // ...(mode === 'light'
            //     ? {
            //           primary: {
            //               main: colors.neutral,
            //           },
            //           secondary: {
            //               main: colors.neutralLight,
            //           },
            //           background: {
            //               paper: '#FAFAFA',
            //           },
            //       }
            //     : {
            //           primary: {
            //               main: colors.neutralLight,
            //           },
            //           secondary: {
            //               main: colors.neutral,
            //           },
            //       }),
            background: {
                default: colors.neutralXXLight,
                paper: colors.neutralXXXLight,
                mobileHelp: colors.black,
                panel: colors.black70,
                footer: colors.neutralLight,
                timebar: colors.white,
                details: colors.white,
                nav: colors.white,
            },
            secondary: {
                main: colors.neutralLight,
            },
            success: {
                main: colors.green,
            },
            error: {
                main: colors.red,
            },
            info: {
                main: colors.blue,
            },
            iconDark: {
                fill: colors.neutral,
                highlight: colors.black,
            },
            iconLight: {
                fill: colors.neutralXLight,
                highlight: colors.white,
            },
            text: {
                primary: colors.black,
                secondary: colors.grey,
                label: colors.neutralDark,
                link: colors.neutralDark,
            },
            textLight: {
                primary: colors.white,
                secondary: colors.neutralXXLight,
                label: colors.neutralXLight,
                link: colors.neutralXLight,
            },
            divider: colors.neutralLight,
        },
    });
    return useResponsiveFontSizes ? responsiveFontSizes(theme) : theme;
};

export default generateTheme;
